import { Link } from "react-router-dom";

const Sector = ({ sectorTitle, slug, image }) => {
	return (
		<Link to={`/projects/sector/${slug}`} state={{ sectorId: slug }} className={`sectors-sectorItem aspect-1_1`}>
			<div className="sector-image">
				<img src={image} alt={`${sectorTitle} Background`} />
			</div>
			<div className="sector-title">
				<span>{sectorTitle}</span>
			</div>
		</Link>
	);
};

export default Sector;
